module.exports = __webpack_public_path__ + "static/gee_logo-2ee5f489885b7082af39b348b399f307.png";